import store from '@/store/store';

import axios, { financesInstance } from '../../axios/axios.js';

const util = {
  getFormattedDateWithTime(timestamp) {
    let date = new Date(timestamp).toISOString();
    let rawTime = date.split('T')[1].substr(0, 8);
    let rawDate = date.split('T')[0].split('-');
    date = `${rawDate[2]}.${rawDate[1]}.${rawDate[0]}. ${rawTime}`;

    return date;
  },
  restructurePoll(data) {
    return data.map(el => {
      let mostPopularOptions = this.getMostPopularOptions(el);
      return {
        dataType: 'poll',
        id: el.post_id,
        authorId: el.author_id,
        authorName: el.author_name,
        body: el.body,
        community: el.community,
        communityId: el.community_id,
        totalVotes: el.votes_total,
        numberOfComments: el.num_of_comments,
        active: util.checkIfActive(Date.parse(el.closes_at))
          ? 'Aktivno'
          : 'Neaktivno',
        mostPopularOption: mostPopularOptions,
        medias: el.medias ? el.medias : [],
        is_pinned: el.is_pinned
      };
    });
  },
  restructureEvent(data) {
    return data.map(el => {
      return {
        dataType: 'event',
        postId: el.post_id,
        eventId: el.event_id,
        authorId: el.author_id,
        authorName: el.author_name,
        profilePictureURL: el.profile_pic.link,
        body: el.body,
        numOfComments: el.num_of_comments,
        active: Date.parse(el.date_to) > new Date() ? 'Aktivno' : 'Neaktivno',
        dateFrom: util.getFormattedDateWithTime(el.date_from),
        dateTo: util.getFormattedDateWithTime(el.date_to),
        createdDate: el.time,
        location: el.location,
        locationGpsLat: el.location_gps_lat,
        locationGpsLong: el.location_gps_long,
        medias: el.medias ? el.medias : [],
        status: el.status,
        divDescription: el.div_description,
        memberWillAttend: el.member_will_attend,
        is_pinned: el.is_pinned
      };
    });
  },
  restructurePost(data, communityId) {
    return data.map(el => {
      return {
        dataType: 'post',
        active: el.active,
        authorId: el.author_id,
        authorName: el.author_name,
        authorUserId: el.author_user_id,
        body: el.body,
        divDescription: el.div_description,
        numOfComments: el.num_of_comments,
        numOfLikes: el.num_of_likes,
        numOfMedia: el.num_of_media,
        postId: el.post_id,
        postType: el.postType,
        profilePic: el.profile_pic,
        time: util.getFormattedDateWithTime(el.time),
        medias: el.medias,
        communityId: communityId,
        is_pinned: el.is_pinned
      };
    });
  },
  restructureMultipleEvents(data, communityId) {
    return data.map(el => {
      return {
        dataType: 'event',
        postId: el.post_id,
        eventId: el.event_id,
        authorId: el.author_id,
        authorName: el.author_name,
        profilePictureURL: el.profile_pic.link,
        body: el.body,
        numOfComments: el.num_of_comments,
        active: Date.parse(el.date_to) > new Date() ? 'Aktivno' : 'Neaktivno',
        dateFrom: util.getFormattedDateWithTime(el.date_from),
        dateTo: util.getFormattedDateWithTime(el.date_to),
        createdDate: el.time,
        location: el.location,
        locationGpsLat: el.location_gps_lat,
        locationGpsLong: el.location_gps_long,
        medias: el.medias ? el.medias : [],
        status: el.status,
        divDescription: el.div_description,
        memberWillAttend: el.member_will_attend,
        communityId: communityId,
        is_pinned: el.is_pinned
      };
    });
  },
  restructureAllPolls(context, data) {
    return data.map(el => {
      let mostPopularOptions = this.getMostPopularOptionsForAllPolls(el);
      let community = context.rootState.communities.communities.find(
        e => e.id === el.community_id
      );
      return {
        dataType: 'poll',
        id: el.id,
        authorId: el.author_id,
        authorName: el.author_name,
        body: el.body,
        totalVotes: el.votes_total,
        numberOfComments: el.num_of_comments,
        active: util.checkIfActive(Date.parse(el.closes_at))
          ? 'Aktivno'
          : 'Neaktivno',
        mostPopularOption: mostPopularOptions,
        communityId: el.community_id,
        community:
          community.address +
          ' ' +
          community.street_number +
          ', ' +
          community.city +
          ', ' +
          community.municipality_name,
        medias: el.medias ? el.medias : []
      };
    });
  },
  restructureTickets(context, data) {
    return data.map(el => {
      let priority;
      if (el.priority_id === '1') priority = 'Nizak';
      if (el.priority_id === '2') priority = 'Srednji';
      if (el.priority_id === '3') priority = 'Visok';
      let community = '';

      if (context) {
        if (context.rootState) {
          community = context.rootState.communities.communities.find(
            e => e.id === el.community_id
          );
        }
      } else {
        community = store.getters.getCommunities.find(
          e => e.id === el.community_id
        );
      }
      var myDate = new Date(el.ticket_date);
      const dayOfMonth = ('0' + myDate.getDate()).slice(-2);
      const month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      const hour = ('0' + myDate.getHours()).slice(-2);
      const minutes = ('0' + myDate.getMinutes()).slice(-2);
      const dateFormatted = `${dayOfMonth}.${month}.${myDate.getFullYear()}. ${hour}:${minutes}`;
      return {
        dataType: 'ticket',
        author: el.author,
        category_id: el.category_id,
        current_status: el.current_status,
        description:
          el.description.length > 25
            ? el.description.substring(0, 25) + '...'
            : el.description,
        div_description: el.div_description,
        id: el.id,
        last_edit: el.last_edit,
        member_id: el.member_id,
        privacy: el.privacy,
        timestamp: el.timestamp,
        title:
          el.title.length > 25 ? el.title.substring(0, 25) + '...' : el.title,
        user_full_name: el.user_full_name,
        priority_id: priority,
        community_id: el.community_id,
        community_infrastructure_id: el.community_infrastructure_id,
        infrastructureName: el.infrastructureName,
        community:
          context !== null && community
            ? community.address +
              ' ' +
              community.street_number +
              ', ' +
              community.city +
              ', ' +
              community.municipality_name
            : '',
        timestampString: dateFormatted
      };
    });
  },
  shortenStringIfNeeded(array) {
    array.map(r => {
      r.title =
        r.title.length > 55 ? r.title.substring(0, 55) + '...' : r.title;
      r.description =
        r.description.length > 55
          ? r.description.substring(0, 55) + '...'
          : r.description;
      return r;
    });
    return array;
  },
  getMostPopularOptions(el) {
    let votingItems = el.voting_items;
    let popularOptions = [];
    if (el.voting_stats) {
      let maxVotes = Math.max(...Object.values(el.voting_stats[0]));
      let stats = el.voting_stats[0];
      if (maxVotes === 0) {
        return '/';
      }
      for (let i = 0; i < Object.values(votingItems).length; i++) {
        let key = 'o' + (i + 1) + '_count';
        if (stats[key] == maxVotes) {
          popularOptions.push(votingItems[i].text);
        }
      }
    } else {
      return 'Nema glasova';
    }
    return popularOptions.join(', ');
  },
  getMostPopularOptionsForAllPolls(el) {
    let popularOptions = [];

    let flag = el.voting_items.find(e => e.count !== '0');

    if (flag) {
      let maxVotes = Math.max.apply(Math, el.voting_items.map(e => e.count));
      el.voting_items.forEach(e => {
        if (e.count == maxVotes) {
          popularOptions.push(e.text);
        }
      });
    } else {
      return 'Nema glasova';
    }
    return popularOptions.join(', ');
  },
  checkIfActive(closesAtDate) {
    return closesAtDate > new Date();
  }
};

export default {
  state: {
    tableColumns: null,
    tableData: null,
    tableOptions: null,
    numberOfPendingMembersForCosmmunity: 0,
    tableBadge: '',
    tableCount: 0,
    pollsFilter: false,
    infrastructure: [],
    calendarEvents: [],
    reminder: null
  },
  mutations: {
    setInfrastructure(state, payload) {
      state.infrastructure = payload;
    },
    setReminder(state, payload) {
      state.reminder = payload;
    },
    showOnlyMyPolls(state) {
      state.pollsFilter = true;
    },
    showAllPolls(state) {
      state.pollsFilter = false;
    },
    resetNumberOfNotifications(state) {
      //broj na tabu
      state.numberOfPendingMembersForCommunity = 0;
    },
    setTableOptions(state, payload) {
      state.tableColumns = payload.tableColumns;
      state.tableOptions = payload.tableOptions;
    },
    setTableData(state, payload) {
      state.tableData = payload;
    },
    setCalendarEvents(state, payload) {
      state.calendarEvents = payload;
    },
    changeNumberOfNotifications(state, payload) {
      state.numberOfPendingMembersForCommunity = payload;
    },
    setTableBadge(state, payload) {
      state.tableBadge = payload;
    },
    setRestructuredTableData(state, payload) {
      let data;
      if (payload.withCommunity) {
        data = util.restructureTickets(true, payload);
      } else {
        data = util.restructureTickets(false, payload);
      }

      state.tableData = data;
    },
    setTableCount(state, payload) {
      state.tableCount = parseInt(payload);
    },
    unsetTableData(state) {
      state.tableData = null;
      state.tableColumns = null;
      state.tableOptions = null;
    }
  },
  actions: {
    initTable(context, type) {
      let table;

      switch (type) {
        case 'pollTable':
          context.dispatch('initPollTable');
          break;
        case 'memberTable':
          context.dispatch('initMemberTable');
          break;
        case 'memberPendingTable':
          table = {
            tableColumns: ['user_full_name', 'div_desc', 'pending'],
            tableOptions: {
              headings: {
                user_full_name: 'Prezime i ime',
                div_desc: 'Opis',
                pending: 'Na čekanju'
              },
              texts: {
                filter: '',
                filterPlaceholder: 'Pretraži',
                count: '',
                noResults: 'Ne postoje korisnici na čekanju'
              },
              sortable: ['user_full_name'],
              perPage: 18
            }
          };
          context.commit('setTableOptions', table);
          break;
        case 'eventTable':
          context.dispatch('initEventTable');
          break;
        case 'postsTable':
          context.dispatch('initPostsTable');
          break;
        case 'communityFinancesTable':
          context.dispatch('initCommunityFinancesTable');
          break;
        case 'communityFinancesTransactionsTable':
          context.dispatch('initCommunityFinancesTransactionsTable');
          break;
        case 'communityFinancesExpensesTable':
          context.dispatch('initCommunityFinancesExpensesTable');
          break;
        case 'communityFinancesInvoicesTable':
          context.dispatch('initCommunityFinancesInvoicesTable');
          break;
        case 'communityFinancesMemberTransactionsTable':
          context.dispatch('initCommunityFinancesMemberTransactionsTable');
          break;
        case 'homeCommunitiesTable':
          context.dispatch('initHomeCommunitiesTable');
          break;
        case 'ticketsTable':
          context.dispatch('initTicketTable');
          break;
        case 'tableAllTickets':
          context.dispatch('initAllTicketsTable');
          break;
        case 'tableAllPolls':
          context.dispatch('initAllPollsTable');
          break;
        case 'tableTreasuryCommunities':
          context.dispatch('initTreasuryCommunitiesTable');
          break;
        case 'notificationsTable':
          context.dispatch('initNotificationsTable');
          break;
      }
    },
    initHomeCommunitiesTable(context) {
      let table = {
        tableColumns: ['name', 'community_type'],
        tableOptions: {
          headings: {
            name: 'Naziv zajednice',
            community_type: 'Tip zajednice'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje zajednice sa datim kriterijumom'
          }
        }
      };
      context.commit('setTableOptions', table);
      let tableData = context.rootGetters.getCommunitiesImploded;
      context.commit('setTableData', tableData);
    },
    initPollTable(context) {
      let table = {
        tableColumns: [
          'authorName',
          'body',
          'totalVotes',
          'numberOfComments',
          'active',
          'mostPopularOption',
          'pin',
          'action'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            authorName: 'Pokretač glasanja',
            body: 'Naslov',
            totalVotes: 'Ukupno glasova',
            numberOfComments: 'Ukupno komentara',
            active: 'Aktivno',
            mostPopularOption: 'Najpopularnija opcija',
            pin: 'Pin',
            action: 'Akcija'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje glasanja'
          },
          sortable: ['closes_at']
        }
      };
      context.commit('setTableOptions', table);
    },
    initCommunityFinancesTable(context) {
      let table = {
        tableColumns: ['div_description', 'full_name', 'balance', 'action'],
        tableOptions: {
          filterable: true,
          headings: {
            div_description: 'Opis stana',
            full_name: 'Vlasnik stana',
            balance: 'Stanje (RSD)',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje stanovi'
          },
          sortable: ['div_description', 'balance']
        }
      };
      context.commit('setTableOptions', table);
    },
    initCommunityFinancesTransactionsTable(context) {
      let table = {
        tableColumns: [
          'div_description',
          'description',
          'timestamp',
          'income',
          'expense',
          'balance',
          'action'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            div_description: 'Komitent',
            description: 'Opis',
            timestamp: 'Datum',
            income: 'Prihod (RSD)',
            expense: 'Rashod (RSD)',
            balance: 'Stanje (RSD)',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje transakcije'
          },
          sortable: ['div_description', 'timestamp'],
          customSorting: {
            timestamp: function(ascending) {
              return function(a, b) {
                if (ascending) {
                  return new Date(a) < new Date(b) ? 1 : -1;
                } else {
                  return new Date(a) < new Date(b) ? -1 : 1;
                }
              };
            }
          }
        }
      };
      context.commit('setTableOptions', table);
    },
    initCommunityFinancesExpensesTable(context) {
      let table = {
        tableColumns: ['name', 'price', 'action'],
        tableOptions: {
          filterable: true,
          headings: {
            name: 'Opis',
            price: 'Iznos (RSD)',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje obaveze'
          },
          sortable: ['price']
        }
      };
      context.commit('setTableOptions', table);
    },
    initCommunityFinancesInvoicesTable(context) {
      let table = {
        tableColumns: ['description', 'total_amount', 'timestamp', 'action'],
        tableOptions: {
          filterable: true,
          headings: {
            description: 'Opis',
            total_amount: 'Iznos (RSD)',
            timestamp: 'Datum kreiranja',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje obaveze'
          },
          sortable: ['total_amount', 'timestamp'],
          customSorting: {
            timestamp: function(ascending) {
              return function(a, b) {
                if (ascending) {
                  return new Date(a) < new Date(b) ? 1 : -1;
                } else {
                  return new Date(a) < new Date(b) ? -1 : 1;
                }
              };
            }
          }
        }
      };
      context.commit('setTableOptions', table);
    },
    initCommunityFinancesMemberTransactionsTable(context) {
      let table = {
        tableColumns: ['description', 'timestamp', 'amount', 'balance'],
        tableOptions: {
          filterable: true,
          headings: {
            description: 'Opis',
            timestamp: 'Datum',
            amount: 'Iznos (RSD)',
            balance: 'Stanje (RSD)',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje transakcije'
          },
          sortable: ['timestamp']
        }
      };
      context.commit('setTableOptions', table);
    },
    initMemberTable(context) {
      let table = {
        tableColumns: ['fullName', 'div_desc', 'totalPoints', 'active'],
        tableOptions: {
          headings: {
            fullName: 'Prezime i ime',
            div_desc: 'Opis',
            totalPoints: 'Broj glasačkih poena',
            active: 'Uredi'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje aktivni članovis'
          },
          sortable: ['user_full_name'],
          perPage: 18
        }
      };
      context.commit('setTableOptions', table);
    },
    initEventTable(context) {
      let table = {
        tableColumns: [
          'authorName',
          'body',
          'location',
          'dateFrom',
          'dateTo',
          'numOfComments',
          'active',
          'pin',
          'action'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            authorName: 'Kreator događaja',
            body: 'Naslov',
            location: 'Mesto okupljanja',
            dateFrom: 'Početak',
            dateTo: 'Kraj',
            numOfComments: 'Ukupno komentara',
            active: 'Aktivno',
            pin: 'Pin',
            action: 'Akcija'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje događaji'
          },
          sortable: ['']
        }
      };
      context.commit('setTableOptions', table);
    },
    initPostsTable(context) {
      let table = {
        tableColumns: [
          'authorName',
          'body',
          'time',
          'numOfComments',
          'numOfLikes',
          'pin',
          'action'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            authorName: 'Stanar',
            body: 'Sadržaj',
            numOfComments: 'Broj komentara',
            numOfLikes: 'Broj lajkova',
            time: 'Vreme',
            pin: 'Pin',
            action: 'Akcija'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje objave'
          },
          sortable: []
        }
      };
      context.commit('setTableOptions', table);
    },
    initTreasuryCommunitiesTable(context) {
      let table = {
        tableColumns: ['name', 'balance'],
        tableOptions: {
          headings: {
            name: 'Naziv zajednice',
            balance: 'Stanje (RSD)'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Niste upravnik nijedne zajednice'
          }
        }
      };
      context.commit('setTableOptions', table);

      let communityIds = [];
      for (let community of context.rootGetters.getCommunitiesImploded) {
        communityIds.push(community.id);
      }

      let requests = [];

      for (let id of communityIds) {
        requests.push(financesInstance.get(`/communities/${id}/account`));
      }
      let tableData = [];
      Promise.all(requests)
        .then(responses => {
          for (let response of responses) {
            tableData.push({
              name: `${response.data.community.address} ${
                response.data.community.street_number
              } ${response.data.community.type}`,
              balance:
                response.data.community.balance != null
                  ? response.data.community.balance
                  : 0,
              id: response.data.community.id
            });
          }
        })
        .catch(errors => {
          console.log(errors);
        });

      context.commit('setTableData', tableData);
    },
    initTicketTable(context) {
      let table = {
        tableColumns: [
          'priority_id',
          'title',
          'description',
          'infrastructureName',
          'timestampString',
          'current_status',
          'privacy',
          'action'
        ],
        tableOptions: {
          filterable: false,
          headings: {
            priority_id: 'Prioritet',
            title: 'Naslov',
            description: 'Opis',
            infrastructureName: 'Infrastruktura',
            timestampString: 'Datum',
            current_status: 'Status',
            privacy: 'Privatnost',
            action: 'Akcija'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje tiketi'
          },
          sortable: []
        }
      };
      context.commit('setTableOptions', table);
    },
    initAllTicketsTable(context) {
      let table = {
        tableColumns: [
          'priority_id',
          'title',
          'description',
          'timestampString',
          'current_status',
          'privacy',
          'community',
          'action'
        ],
        tableOptions: {
          filterable: false,
          headings: {
            priority_id: 'Prioritet',
            title: 'Naslov',
            description: 'Opis',
            timestampString: 'Datum',
            current_status: 'Status',
            privacy: 'Privatnost',
            action: 'Akcija',
            community: 'Zajednica'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje tiketi'
          },
          sortable: []
        }
      };
      context.commit('setTableOptions', table);
    },
    initNotificationsTable(context) {
      let table = {
        tableColumns: ['body', 'is_read', 'timestamp'],
        tableOptions: {
          filterable: false,
          headings: {
            body: 'Notifikacija',
            is_read: 'Status',
            timestamp: 'Datum nastanka'
          },
          texts: {
            count: '',
            noResults: 'Trenutno nemate notifikacija'
          },
          sortable: [],
          pagination: {
            dropdown: false,
            chunk: 100000,
            edge: false,
            align: 'center',
            nav: 'fixed'
          },
          perPage: 100000
        }
      };
      context.commit('setTableOptions', table);
    },
    initAllPollsTable(context) {
      let table = {
        tableColumns: [
          'authorName',
          'body',
          'totalVotes',
          'numberOfComments',
          'active',
          'mostPopularOption',
          'community',
          'action'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            authorName: 'Pokretač glasanja',
            body: 'Naslov',
            totalVotes: 'Ukupno glasova',
            numberOfComments: 'Ukupno komentara',
            active: 'Aktivno',
            mostPopularOption: 'Najpopularnija opcija',
            community: 'Zajednica',
            action: 'Akcija'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje glasanja'
          },
          sortable: []
        }
      };
      context.commit('setTableOptions', table);
    },
    async getPollsByCommunity(context, payload) {
      const { communityId, memberId } = payload;
      context.commit('loadingStarted', null, {
        root: true
      });
      if (!memberId) {
        return axios
          .post('post/get-posts', {
            community_id: communityId,
            filter_type: '2',
            futureOrPast: 1,
            media_only: false,
            num_of_posts: 15,
            timestamp: '',
            post_id: ''
          })
          .then(({ data }) => {
            context.commit('loadingStarted', null, {
              root: true
            });

            let tableData = util.restructurePoll(data);
            context.commit('setTableData', tableData);
            context.commit('loadingFinished', null, {
              root: true
            });
          })
          .catch(err => {
            context.commit('setTableData', []);
            context.commit('loadingFinished', null, {
              root: true
            });
            console.log(err);
          });
      } else {
        return financesInstance
          .get(`communities/${communityId}/polls?memberId=${memberId}`)
          .then(({ data }) => {
            let tableData = util.restructurePoll(data);
            context.commit('setTableData', tableData);
            context.commit('loadingFinished', null, {
              root: true
            });
          })
          .catch(err => {
            context.commit('setTableData', []);
            context.commit('loadingFinished', null, {
              root: true
            });
            console.log(err);
          });
      }
    },
    getActiveMembersByCommunity(context, communityId) {
      context.commit('loadingStarted', null, {
        root: true
      });

      axios
        .post('member/get-members-by-community', {
          community_id: communityId,
          active: 1
        })
        .then(({ data }) => {
          let tableDataPending = data.filter(d => d.active === '2');
          context.commit(
            'changeNumberOfNotifications',
            tableDataPending.length
          );

          let tableData = data.filter(d => d.active === '1');

          let totalVotes = 0;
          for (let member of tableData) {
            member.dataType = 'member';
            totalVotes += parseInt(member.voting_points);
          }

          for (let member of tableData) {
            member.totalPoints = `${
              member.voting_points
            } / ${totalVotes}  glasova`;
          }

          context.commit('setTableData', tableData);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          context.commit('setTableData', []);
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    getPendingMembersByCommunity(context, communityId) {
      context.commit('loadingStarted', null, {
        root: true
      });
      axios
        .post('member/get-members-by-community', {
          community_id: communityId,
          active: 1
        })
        .then(({ data }) => {
          let tableData = data.filter(d => d.active === '2');
          context.commit('changeNumberOfNotifications', tableData.length);
          context.commit('setTableData', tableData);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          context.commit('setTableData', []);
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    getEventsByCommunity(context, communityId) {
      context.commit('loadingStarted', null, {
        root: true
      });
      axios
        .post('post/get-posts', {
          community_id: communityId,
          filter_type: '3',
          futureOrPast: 1,
          media_only: false,
          num_of_posts: 15,
          timestamp: '',
          post_id: ''
        })
        .then(({ data }) => {
          context.commit('loadingStarted', null, {
            root: true
          });

          let tableData = util.restructureEvent(data);
          context.commit('setTableData', tableData);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          context.commit('setTableData', []);
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    getPostsByCommunity(context, communityId) {
      context.commit('loadingStarted', null, {
        root: true
      });
      axios
        .post('post/get-posts', {
          community_id: communityId,
          filter_type: '1',
          futureOrPast: 1,
          media_only: false,
          num_of_posts: 15,
          timestamp: '',
          post_id: ''
        })
        .then(({ data }) => {
          context.commit('loadingStarted', null, {
            root: true
          });
          let tableData = util.restructurePost(data, communityId);
          context.commit('setTableData', tableData);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          context.commit('setTableData', []);
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    async getAllContractors(context, shouldSetTableData = true) {
      try {
        if (shouldSetTableData) {
          context.commit('loadingStarted', null, {
            root: true
          });
        }
        const result = await axios.get('contractor');
        const tableData = result.data.contractors.map(con => {
          con.address_full_name = `${con.address.street_name} ${
            con.street_number
          }, ${con.address.municipality.name}`;
          return con;
        });
        if (shouldSetTableData) {
          context.commit('setTableData', tableData);
          context.commit('loadingFinished', null, {
            root: true
          });
        }
        return tableData;
      } catch (error) {
        console.log(error);
        context.commit('setTableData', []);
        context.commit('loadingFinished', null, {
          root: true
        });
        return [];
      }
    },
    async getContractor(context, contractorId) {
      const result = await axios.get(`/contractor/${contractorId}`);
      result.data.contractor.contacts = result.data.contractor.contacts.map(
        contact => {
          contact.isExpanded = false;
          return contact;
        }
      );
      // this.contractor = result.data.contractor;
      // this.setContractor(this.contractor);
      // Object.assign(this.contractor, this.$store.state.modal.contractor);
      const contractor = result.data.contractor;
      const tickets = await axios.get(`contractor/${contractor.id}/tickets`);
      const allCommunties = context.rootGetters.getCommunitiesImploded;
      const structuredTickets = tickets.data.data.map(t => {
        t.dataType = 'ticket-contractor';
        t.communityName = '/';
        const community = allCommunties.find(c => c.id == t.community_id);
        if (community) {
          t.communityName = community.name;
        }
        return t;
      });
      contractor.tickets = structuredTickets;

      context.commit('modal/setContractor', contractor, { root: true });
    },
    async getAllProjects(context) {
      try {
        context.commit('loadingStarted', null, {
          root: true
        });
        const result = await axios.get('project');
        const tableData = result.data.data.map(p => {
          p.description =
            p.description.length > 25
              ? p.description.substring(0, 25) + '...'
              : p.description;
          p.title =
            p.title.length > 25 ? p.title.substring(0, 25) + '...' : p.title;
          return p;
        });
        context.commit('setTableData', tableData);
        context.commit('loadingFinished', null, {
          root: true
        });
        return tableData;
      } catch (error) {
        console.log(error);
        context.commit('setTableData', []);
        context.commit('loadingFinished', null, {
          root: true
        });
        return [];
      }
    },
    async getProjectById(context, projectId) {
      const result = await axios.get(`/project/${projectId}`);
      const project = result.data.data;
      project.communities = project.communities.map(c => {
        c.name = `${c.address} ${c.streetNumber}, ${c.municipality}`;
        return c;
      });
      context.commit('modal/setProject', result.data.data, { root: true });
    },
    async getAllUsers(context, userIdToExclude) {
      try {
        context.commit('loadingStarted', null, {
          root: true
        });
        const response = await axios.get('/company/users');
        response.data.users = response.data.users
          .filter(u => u.id != userIdToExclude)
          .map(user => {
            console.log('pre', user);
            user.roleNames = user.roles
              .map(role => {
                console.log(role);
                switch (role) {
                  case 'MANAGER':
                    return 'Upravnik';
                  case 'SUPER_MANAGER':
                    return 'Super Upravnik';
                  default:
                    return 'Upravnik';
                }
              })
              .join(', ');
            console.log('USER', user.roleNames);
            return user;
          });
        context.commit('setTableData', response.data.users);
        context.commit('loadingFinished', null, {
          root: true
        });
      } catch (error) {
        context.commit('setTableData', []);
        console.log(error);
        context.commit('loadingFinished', null, {
          root: true
        });
      }
    },
    async getManagerUserDetails(context, userId) {
      try {
        const response = await axios.get(`company/user/${userId}`);

        return response.data.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async getDocumentForCommunity(context, communityId) {
      try {
        context.commit('loadingStarted', null, {
          root: true
        });
        const response = await axios.get(
          `/community/${communityId}/community-document`
        );
        context.commit('setTableData', response.data.data);
        context.commit('loadingFinished', null, {
          root: true
        });
      } catch (error) {
        context.commit('setTableData', []);
        console.log(error);
        context.commit('loadingFinished', null, {
          root: true
        });
      }
    },
    async getAllInfrastructure(context, data) {
      try {
        context.commit('loadingStarted', null, {
          root: true
        });
        const response = await axios.get(
          `/community/${
            data.communityId
          }/infrastructures-with-contractor-contacts`
        );
        if (data.returnOnlyData) {
          return response.data.data;
        }
        let tableData = response.data.data.map(infra => {
          const type = data.infraTypes.find(
            i => i.value.id == infra.infrastructure_type_id
          );
          if (type) {
            infra.category = type.text;
          }
          return infra;
        });
        tableData = tableData.map(infra => {
          if (infra.contractors.length > 0) {
            infra.contractor = infra.contractors[0].name;
          }
          return infra;
        });
        context.commit('setTableData', tableData);
        context.commit('loadingFinished', null, {
          root: true
        });
        return tableData;
      } catch (error) {
        context.commit('setTableData', []);
        console.log(error);
        context.commit('loadingFinished', null, {
          root: true
        });
      }
    },
    async getInfrastructureCategories(context) {
      try {
        const categoriesResult = await axios.get(
          'infrastructure/infrastructure-types'
        );
        const categories = categoriesResult.data.data.map(cat => {
          return {
            value: {
              id: cat.id,
              name: cat.name
            },
            text: cat.name
          };
        });
        context.commit('modal/setInfrastructureCategories', categories, {
          root: true
        });
        return categories;
      } catch (error) {
        console.log(error);
      }
    },
    async getInfrastructureById(context, infrastructureId) {
      try {
        context.commit('loadingStarted', null, {
          root: true
        });
        const result = await axios.get(`/infrastructure/${infrastructureId}`);
        const infrastructureResult = result.data.data;
        infrastructureResult.contractors = infrastructureResult.contractors.map(
          contractor => {
            contractor.isExpanded = false;
            return contractor;
          }
        );
        context.commit('setInfrastructure', infrastructureResult);
        context.commit('loadingFinished', null, {
          root: true
        });
      } catch (error) {
        context.commit('loadingFinished', null, {
          root: true
        });
        throw error;
      }
    },
    async getReminderById(context, reminderId) {
      try {
        context.commit('loadingStarted', null, {
          root: true
        });
        const result = await axios.get(`/reminder/${reminderId}`);
        const reminderResult = result.data.data;
        context.commit('setReminder', reminderResult);
        context.commit('loadingFinished', null, {
          root: true
        });
      } catch (error) {
        context.commit('loadingFinished', null, {
          root: true
        });
        throw error;
      }
    },
    async getEventsForMultipleCommunities(context, communityIds) {
      context.commit('loadingStarted', null, {
        root: true
      });
      try {
        let allEvents = [];
        for (const communityId of communityIds) {
          const response = await axios.post('post/get-posts', {
            community_id: communityId,
            filter_type: '3',
            futureOrPast: 1,
            media_only: false,
            num_of_posts: 15,
            timestamp: '',
            post_id: ''
          });
          let tableData = util.restructureMultipleEvents(
            response.data,
            communityId
          );
          for (const event of tableData) {
            allEvents.push(event);
          }
        }
        allEvents.sort((a, b) =>
          parseInt(a.postId) < parseFloat(b.postId) ? 1 : -1
        );
        context.commit('setTableData', allEvents);
        context.commit('loadingFinished', null, {
          root: true
        });
      } catch (error) {
        context.commit('setTableData', []);
        context.commit('loadingFinished', null, {
          root: true
        });
      }
    },
    getNotificationNumber(context, communityId) {
      axios
        .post('member/get-members-by-community', {
          community_id: communityId,
          active: 1
        })
        .then(res => {
          let tableDataPending = res.data.filter(d => d.active === '2');
          context.commit(
            'changeNumberOfNotifications',
            tableDataPending.length
          );
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getTicketsByCommunity(context, data) {
      context.commit('loadingStarted', null, {
        root: true
      });
      const response = await axios.get(
        `/community/${data.communityId}/infrastructures-with-contractors`
      );
      const infrastructures = response.data.data;
      axios
        .get(`tickets?member_id=${data.memberId}`, { params: data.params })
        .then(res => {
          let tableData = util.restructureTickets(null, res.data.data);
          tableData = tableData.map(t => {
            t.infrastructureName = '/';
            if (t.community_infrastructure_id) {
              const infra = infrastructures.find(
                i => i.id == t.community_infrastructure_id
              );
              if (infra) {
                t.infrastructureName = infra.name;
              }
            }
            return t;
          });
          context.commit('setTableData', tableData);
          context.commit('setTableCount', res.data.count);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          context.commit('setTableData', []);
          context.commit('setTableCount', 0);
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    async getAllTickets(context, params) {
      context.commit('loadingStarted', null, {
        root: true
      });
      axios
        .get(`tickets/user?`, { params })
        .then(res => {
          let tableData = util.restructureTickets(context, res.data.data);
          context.commit('setTableCount', res.data.count);
          context.commit('setTableData', tableData);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          context.commit('setTableData', []);
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    async getAllPolls(context, communitiesData) {
      context.commit('loadingStarted', null, {
        root: true
      });
      if (communitiesData) {
        //get all polls made by user
        const requests = [];
        for (const data of communitiesData) {
          requests.push(context.dispatch('getPollsByCommunity', data));
        }
        Promise.all(requests).catch(err => {
          console.log(err);
        });
      } else {
        //no user id - get all polls
        await axios
          .get('post/get-polls')
          .then(({ data }) => {
            let tableData = util.restructureAllPolls(context, data.data);
            context.commit('setTableData', tableData);
            context.commit('loadingFinished', null, {
              root: true
            });
          })
          .catch(err => {
            context.commit('setTableData', []);
            context.commit('loadingFinished', null, {
              root: true
            });
            console.log(err);
          });
      }
    },
    async getAllMembersForCommunityFinances(context, communityId) {
      context.commit('loadingStarted', null, {
        root: true
      });
      try {
        const res = await financesInstance.get(
          `communities/${communityId}/members`
        );
        let tableData = res.data.members;
        for (let member of tableData) {
          member.dataType = 'virtualMember';
        }

        context.commit('setTableCount', res.data.count);
        context.commit('setTableData', tableData);
        context.commit('loadingFinished', null, {
          root: true
        });
        return tableData;
      } catch (err) {
        context.commit('setTableData', [
          {
            id: '1',
            div_description: 'Broj stana',
            memberFullname: 'Vlasnik stana',
            balance: 'Stanje (RSD)'
          }
        ]);
        context.commit('loadingFinished', null, {
          root: true
        });
        console.log(err);
      }
    },
    async getCommunityReminders(context, params) {
      context.commit('loadingStarted', null, {
        root: true
      });
      try {
        const data = await axios.get(
          `reminder?communityId=${params.communityId}`,
          { params: params.filters }
        );
        const tableData = util.shortenStringIfNeeded(data.data.data);
        const events = tableData.map(r => {
          const nextDate = new Date(r.nextInstance);
          const firstDigit = nextDate.getMinutes() < 10 ? '0' : '';
          const minutes = `${firstDigit}${nextDate.getMinutes()}`;
          return {
            key: r.id,
            customData: {
              title: r.title,
              time: `${nextDate.getHours()}:${minutes}`,
              id: r.id,
              communityId: r.communityId
            },

            dates: Date.parse(r.nextInstance)
          };
        });
        context.commit('setTableData', tableData);
        context.commit('setCalendarEvents', events);
        context.commit('loadingFinished', null, {
          root: true
        });
        return tableData;
      } catch (err) {
        context.commit('setTableData', []);
        context.commit('loadingFinished', null, {
          root: true
        });
        console.log(err);
      }
    },
    async getAllMembersForCommunityFinances(context, communityId) {
      context.commit('loadingStarted', null, {
        root: true
      });
      try {
        const res = await financesInstance.get(
          `communities/${communityId}/members`
        );
        let tableData = res.data.members;
        for (let member of tableData) {
          member.dataType = 'virtualMember';
        }

        context.commit('setTableCount', res.data.count);
        context.commit('setTableData', tableData);
        context.commit('loadingFinished', null, {
          root: true
        });
        return tableData;
      } catch (err) {
        context.commit('setTableData', [
          {
            id: '1',
            div_description: 'Broj stana',
            memberFullname: 'Vlasnik stana',
            balance: 'Stanje (RSD)'
          }
        ]);
        context.commit('loadingFinished', null, {
          root: true
        });
        console.log(err);
      }
    },
    async getAllReminders(context, filterData) {
      context.commit('loadingStarted', null, {
        root: true
      });
      try {
        const data = await axios.get('reminder/all', {
          params: filterData.filters
        });
        let tableData = util.shortenStringIfNeeded(data.data.data);
        tableData = tableData.map(r => {
          let community = store.getters.getCommunities.filter(
            c => c.community_id == r.communityId
          );
          r.communityName =
            community[0].address + ' ' + community[0].street_number;
          return r;
        });
        const events = tableData.map(r => {
          const nextDate = new Date(r.nextInstance);
          const firstDigit = nextDate.getMinutes() < 10 ? '0' : '';
          const minutes = `${firstDigit}${nextDate.getMinutes()}`;
          return {
            key: r.id,
            customData: {
              title: r.title,
              time: `${nextDate.getHours()}:${minutes}`,
              id: r.id,
              communityId: r.communityId
            },

            dates: Date.parse(r.nextInstance)
          };
        });
        context.commit('setTableData', tableData);
        context.commit('setCalendarEvents', events);
        context.commit('loadingFinished', null, {
          root: true
        });
        return tableData;
      } catch (err) {
        context.commit('setTableData', []);
        context.commit('loadingFinished', null, {
          root: true
        });
        console.log(err);
      }
    }
  },
  getters: {
    getActiveCardBadge(state) {
      return state.tableBadge;
    },
    getNumberOfPendingMembers(state) {
      return state.numberOfPendingMembersForCommunity;
    },
    getTableData(state) {
      return state.tableData;
    }
  },
  namespaced: true
};
